import { Color } from "@amcharts/amcharts5/.internal/core/util/Color";

/**
 * Crear una lÍnea en la gráfica como puede ser la media.
 * @param yAxis
 * @param value
 * @param endValue
 * @param color
 * @param dashed
 * @returns
 */
export const createRange = (
  yAxis: any,
  value: number,
  endValue: number | undefined,
  color: Color,
  dashed: boolean
) => {
  const rangeDataItem = yAxis.makeDataItem({
    value: value,
    endValue: endValue,
  });

  const range = yAxis.createAxisRange(rangeDataItem);

  if (endValue) {
    range.get("axisFill").setAll({
      fill: color,
      fillOpacity: 0,
      visible: false,
    });
  } else {
    range.get("grid").setAll({
      stroke: color,
      strokeOpacity: 0.2,
      strokeWidth: 2,
      location: 1,
    });

    if (dashed) {
      range.get("grid").set("strokeDasharray", [5, 5]);
    }
  }

  return { rangeDataItem, range };
};
